import Head from '@/components/ui/Head';

// Injects a JSON-LD <script> into <head>.
// Pass a plain JS object (from src/lib/jsonld.js); null renders nothing.
export default function JsonLd({ data }) {
  if (!data) return null;
  return <Head jsonLd={data} />;
}